import isDescendant from "@/utils/isDescendant.js";

export default function showPopupMenu(element, data) {
  const targetSelector = data.target;
  const className = data.class;
  const autoclose = data.autoclose || null;
  const allowTargetClick = data.allowTargetClick || false;

  let timeout = null;

  element.addEventListener("click", function () {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }

    const targets = document.querySelectorAll(targetSelector);

    if (targets && targets.length > 0) {
      targets.forEach(function (target) {
        target.classList.toggle(className);
      });
    }

    if (autoclose) {
      timeout = setTimeout(function () {
        timeout = null;
        if (targets && targets.length > 0) {
          targets.forEach(function (target) {
            target.classList.remove(className);
            console.log("autoclose");
          });
        }
      }, parseInt(autoclose));
    }
  });

  window.addEventListener("click", function (event) {
    if (isDescendant(element, event.target)) {
      return;
    }

    if (allowTargetClick) {
      const target = document.querySelector(targetSelector);

      if (isDescendant(target, event.target)) {
        return;
      }
    }

    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }

    const targets = document.querySelectorAll(targetSelector);

    if (targets && targets.length > 0) {
      targets.forEach(function (target) {
        target.classList.remove(className);
      });
    }
  });
}
